import React from 'react'
import {
  GetArticleBoxListQuery,
  GetArticleBoxListQueryVariables,
} from '../graphql/content/generated/graphql-types'
import { useGraphql } from '../hooks'
import { GET_ARTICLE_BOX_LIST_QUERY } from '../graphql/content/get-article-box-list.graphql'
import { Scalars } from '../graphql/content/generated/graphql-types'

type HOCProps = {
  tags?: string
  skip?: boolean
  numberOfBoxes?: number
  excludeDate?: boolean
  articleIds?: Array<Scalars['Int']> | Scalars['Int']
}

export const withArticles = (WrappedComponent: React.ComponentType<any & HOCProps>) =>
  function ArticlesData(props: any & HOCProps) {
    const { data, isValidating: isLoading } = useGraphql<
      GetArticleBoxListQuery,
      GetArticleBoxListQueryVariables
    >(GET_ARTICLE_BOX_LIST_QUERY, {
      variables: {
        mustIncludeAllTags: false,
        numberOfBoxes: props?.numberOfBoxes || 3,
        startIndex: 0,
        tagNames: props?.tags || [],
        categoryNames: [],
        articleIds: props?.articleIds || [],
      },
      context: {
        skip: props.skip,
      },
    })

    const blogUrl = data?.articleBoxList?.blogUrl ?? ''
    let articlesList = data?.articleBoxList?.articles ?? []
    if (props.excludeDate && articlesList.length) {
      articlesList = articlesList.map(({ postDateText, ...rest }) => {
        return { postDateText: '', ...rest }
      })
    }

    return <WrappedComponent {...{ ...props, articlesList, isLoading, blogUrl }} />
  }
